export default "<html>\n\n<body>\n    <router-outlet></router-outlet>\n    <app-iframe-listener></app-iframe-listener>\n</body>\n\n</html>\n";